/**
 * GOV.CZ Optimus UI Provider (fork PrimeNG)
 *
 * Použití:
 *   import { provideGovPrimeNG } from '@shared/themes';
 *
 *   export const appConfig: ApplicationConfig = {
 *     providers: [
 *       provideGovPrimeNG(),
 *     ],
 *   };
 */
import { provideOptimus } from '@openng/optimus-ui/config';
import { GovThemePreset } from './gov-theme.preset';

/**
 * @param cssLayerOrder Pořadí CSS vrstev. Optimus ho deklaruje jako první v `<head>`, proto rozhoduje
 *   i o vrstvách aplikace; musí souhlasit s prvním řádkem `gov-theme.css`.
 */
export function provideGovPrimeNG(cssLayerOrder = 'theme, base, optimus, ds') {
  return provideOptimus({
    theme: {
      preset: GovThemePreset,
      options: {
        cssLayer: {
          name: 'optimus',
          order: cssLayerOrder,
        },
        darkModeSelector: '.dark',
      },
    },
    // Overlaye (select, autocomplete, kalendář) se jinak ořezávají v kontejnerech s overflow;
    // převzato z eparagrafu.
    overlayAppendTo: 'body',
  });
}
